import {Button, Header as GrommetHeader} from 'grommet'
import styled from 'styled-components'

import {breakpoints} from '@mindthecoin/shiny'

import Logo from '../../../images/icons/Logo'
import {useAuth} from '../../auth/AuthContext'
import { useIntl } from 'react-intl'

const LogoWrapper = styled.div`
  & > svg {
    display: block;
    width: 14rem;
    margin: 0.5em 0;
  }

  @media (min-width: ${breakpoints.small.value}px) {
    & > svg {
      width: 16rem;
      margin: 0.2em 0;
    }
  }
`

export default function Header() {
  const {
    isLoggedIn,
    logout,
  } = useAuth()
  const intl = useIntl()

  return (
    <GrommetHeader
      gridArea="header"
      align="center"
      alignContent="center"
      justify={isLoggedIn ? 'between' : 'center'}
      background="dark-2"
      pad={{vertical: 'small', horizontal: 'small'}}
      round={{corner: 'top'}}
      responsive
    >
      <LogoWrapper>
        <Logo background="dark" />
      </LogoWrapper>
      {isLoggedIn && <Button onClick={logout} label={intl.formatMessage({id: 'common.logout'})} />}
    </GrommetHeader>
  )
}
